import { render, staticRenderFns } from "./PanoramaTableSwiper.vue?vue&type=template&id=703acf90&scoped=true"
import script from "./PanoramaTableSwiper.vue?vue&type=script&lang=js"
export * from "./PanoramaTableSwiper.vue?vue&type=script&lang=js"
import style0 from "./PanoramaTableSwiper.vue?vue&type=style&index=0&id=703acf90&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703acf90",
  null
  
)

export default component.exports